/**
 * @class ColorantPackage
 */
export default class ColorantPackage {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  colorantName
     * @param {Number}  unit
     * @param {Number}  nominalAmount
     * @param {Number}  filling
     * @param {Number}  fillingMl
     * @param {Boolean} isGravimetric
     * @param {Object}  colorant
     * @param {Object}  pckg
     */
    constructor(id, name, colorantName, unit, nominalAmount, filling, fillingMl, isGravimetric, colorant, pckg) {
        this._id = id;
        this._name = name;
        this._colorantName = colorantName;
        this._unit = unit;
        this._nominalAmount = nominalAmount;
        this._filling = filling;
        this._fillingMl = fillingMl;
        this._isGravimetric = isGravimetric;
        this._colorant = colorant;
        this._package = pckg;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - ColorantPackage");
        }

        if (this._colorant === null || this._package === null) {
            throw new Error("Invalid ColorantPackage values");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get colorantName() {
        return this._colorantName;
    }

    /**
     * @param {String} colorantName
     */
    set colorantName(colorantName) {
        this._colorantName = colorantName;
    }

    /**
     * @return {Number}
     */
    get unit() {
        return this._unit;
    }

    /**
     * @param {Number} unit
     */
    set unit(unit) {
        this._unit = unit;
    }

    /**
     * @return {Number}
     */
    get nominalAmount() {
        return this._nominalAmount;
    }

    /**
     * @param {Number} nominalAmount
     */
    set nominalAmount(nominalAmount) {
        this._nominalAmount = nominalAmount;
    }

    /**
     * @return {Number}
     */
    get filling() {
        return this._filling;
    }

    /**
     * @param {Number} filling
     */
    set filling(filling) {
        this._filling = filling;
    }

    /**
     * @return {Number}
     */
    get fillingMl() {
        return this._fillingMl;
    }

    /**
     * @param {Number} fillingMl
     */
    set fillingMl(fillingMl) {
        this._fillingMl = fillingMl;
    }

    /**
     * @return {Boolean}
     */
    get isGravimetric() {
        return this._isGravimetric;
    }

    /**
     * @param {Boolean} isGravimetric
     */
    set isGravimetric(isGravimetric) {
        this._isGravimetric = isGravimetric;
    }

    /**
     * @return {object}
     */
    get colorant() {
        return this._colorant;
    }

    /**
     * @param {object} colorant
     */
    set colorant(colorant) {
        this._colorant = colorant;
    }

    /**
     * @return {object}
     */
    get package() {
        return this._package;
    }

    /**
     * @param {object} pckg
     */
    set package(pckg) {
        this._package = pckg;
    }

    /**
     * @return {String}
     */
    toString() {
        return "ColorantPackage (" + this._id + ")";
    }
}
